import React from "react";
import { useBundleContext } from "./BundleContext";
import { Sell } from "@mui/icons-material";

export const BundleIncentive = () => {
  const { bundle } = useBundleContext();
  return (
    <div className="flex items-center space-x-1.5">
      <Sell className="text-secondary" style={{ fontSize: 16 }} />
      <p className="text-sm font-bold">{bundle.incentive}</p>
    </div>
  );
};
